import { useContext } from 'react'
import { useInfiniteQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'
import UserContext from 'context/user-context'

const getAccessManagementAuditLogs = async ({
  token,
  municipalityId,
  pageParam = 1,
  baseParams
}) => {
  const params = {
    ...baseParams,
    page: pageParam,
    perPage: 25
  }
  const url = `municipalities/${municipalityId}/sod_audit_logs`
  const data = await apiGet({ url, token, params })
  return data
}

export function useAccessManagementAuditLogs({ baseParams, options }) {
  const token = useContext(AuthContext)
  const { municipality_id } = useContext(UserContext)

  return useInfiniteQuery(
    ['sod_audit_logs', baseParams],
    ({ pageParam = 1 }) =>
      getAccessManagementAuditLogs({
        token,
        municipalityId: municipality_id,
        pageParam,
        baseParams
      }),
    {
      getNextPageParam: (lastPage, allPages) =>
        lastPage.length === 25 ? allPages.length + 1 : undefined,
      ...options
    }
  )
}
